<div class="wrapper">
  <div class="leftContainer" data-ctx="container-left">
    <div class="checkboxWrapper">
      <gl-checkbox
        [ngModel]="gravityShowCenter"
        [defaultChecked]="gravityShowCenter"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="modelChange()"
        [disabled]="!hasDimensions"
        >
        {{ 'show_gravity_center' | translate }}
      </gl-checkbox>
      <div [glTooltip]="'select_center_of_gravity_axis_info'" [width]="'530px'" class="info">i</div>
    </div>
    @if (loadData?.loadType !== 1 && loadData?.loadType !== 2) {
      <form
        class="form"
        [formGroup]="form"
        >
        <div class="titleWrapper">
          <div>{{ 'select_center_of_gravity_axis' | translate: { axis: 'X' } }}</div>
        </div>
        <div class="slider">
          <gl-slider [unit]="unit" [max]="maxWidth" [min]="0" formControlName="axisX"></gl-slider>
        </div>
        <div class="titleWrapper">
          <div>{{ 'select_center_of_gravity_axis' | translate: { axis: 'Y' } }}</div>
        </div>
        <div class="slider">
          <gl-slider [unit]="unit" [max]="maxHeight" [min]="0" formControlName="axisY"></gl-slider>
        </div>
        <div class="titleWrapper">
          <div>{{ 'select_center_of_gravity_axis' | translate: { axis: 'Z' } }}</div>
        </div>
        <div class="slider">
          <gl-slider [unit]="unit" [max]="maxLength" [min]="0" formControlName="axisZ"></gl-slider>
        </div>
      </form>
    }
  </div>
  <div class="visualisation">
    <gl-load-preview
      [height]="330"
      [loadData]="loadDataVis"
      [project]="project"
      [width]="385"
    ></gl-load-preview>
  </div>
</div>
